import React from 'react';

import Modal from '../../components/Modal';
import AgreementSign from './Sign';

const Definitions = () => (
  <div>
    <AgreementSign />
    <Modal className="definitions">
      <div className="card-header">
        <button type="button" className="btn-back">Back</button>
        <h5>Definitions</h5>
      </div>
      <div className="card-content">
        <p>
          <strong>6-Month ZIP Promotion (Zero interest rate on Principal option)</strong>
          {' '}
          – You may pay the pricipal amount of your loan without paying any interest on the unpaid principal balance. In order to prevent paying interest on the unpaid principal, including interest accrued during the six month promotional period, you must pay us the principal amount of your loan by the due date of your sixth scheduled monthtly payment. We will keep any prepaid finance charge (including the non-refundable loan origination) that is included the principal you owe.
        </p>
        <p>
          <strong>APR – An Annual Percentage Rate (APR)</strong>
          {' '}
          is the annual rate charged for borrowed funds, inclusive of all fees and charges. LendingUSA calculates APR by combing the interest rate and the Origination fees to provide a simple yearly rate.
        </p>
        <p>
          <strong>Interest Rate</strong>
          {' '}
          – The interest rate is the perfect of principal charged by the lender for the use of its funds.
        </p>
        <p>
          <strong>Origination Fee</strong>
          {' '}
          – An origination fee of up to 8% may be included in your loan, please review your Loan Agreement for full details.
        </p>
      </div>
    </Modal>
  </div>
);

export default Definitions;
